import { render, staticRenderFns } from "./addExpiretime.vue?vue&type=template&id=ce2359c0&"
import script from "./addExpiretime.vue?vue&type=script&lang=js&"
export * from "./addExpiretime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports